import * as React from 'react';
import { Box, Chip, useMediaQuery, Theme } from '@mui/material';
import {

    List,
    EditButton,
    Datagrid,
    TextField, DateField, NumberField, SelectInput, required, ReferenceField,
    Link,
    ReferenceManyCount,
    useRecordContext,
    Filter,
    TextInput,
} from 'react-admin';
import ThumbnailField from "../../common/ThumbnailField";
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import { STATUS, STATUSES } from "../../common/constants";
import { DeleteWithDialogAction } from "../../common/DeleteWithDialogAction";
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const IssuesLinkComponent = () => {
    const record = useRecordContext();
    return <Link
        to={`/issues?displayedFilters={}&filter=${encodeURIComponent(JSON.stringify({ issueTopicId: record.id }))}`}>
        Issues
    </Link>
}
const IssueFilter = (props: any) => {
    return (
        <Filter {...props}>
            <TextInput variant={'outlined'} label="Name" source="name" alwaysOn={true} defaultValue="" />
            <TextInput variant={'outlined'} label="Slug" source="slug" alwaysOn={true} defaultValue="" />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                alwaysOn={true}
                choices={STATUS}
            />
        </Filter>
    );
}

const IssueTopicList = () => {

    return (
        <List
            queryOptions={{
                refetchOnReconnect: false,
                refetchOnWindowFocus: false,
            }}
            filters={<IssueFilter />}
            sort={{ field: 'createdAt', order: 'DESC' }}
        >
            <Datagrid>
                <TextField source="name" />
                <TextField source="slug" />
                <IssuesLinkComponent />
                <TextField source="status" />
                <FormattedDateTimeField source="createdAt" />

                <EditButton />
                <ConfirmDeleteButton />
            </Datagrid>
        </List>
    );
};
export default IssueTopicList;
